function useWebEngageClickGame() {
  const tracWebEngageClickGame = () => {
    try {
      window.webengage.track("click game banichance s1404");
    } catch (error) {
      console.log("🚀 ~ click game ~ error:", error);
    }
  };

  return { tracWebEngageClickGame };
}

export default useWebEngageClickGame;
